<template>
  <button
    type="button"
    data-testid="add-area-button"
    class="flex items-center w-full bg-black text-white text-left px-5 py-3 focus:outline-none hover:bg-black hover:bg-opacity-70 focus:bg-opacity-50 transition-opacity duration-300"
    @click="$emit('click')"
  >
    <div class="w-5 h-5 mr-5">
      <IconAdd />
    </div>
    Add another area
  </button>
</template>

<script>
import IconAdd from "../../../../templates/_includes/svg/icon-add.svg";

export default {
  name: "AddButton",
  components: { IconAdd },
};
</script>
